// Card-network identification, kept apart from the icon component so it can be
// tested: the bun test SVG plugin stubs every .svg to a component that renders
// null, so nothing observable distinguishes one brand's icon from another's.

export type PaymentBrandKey =
  | 'visa'
  | 'mastercard'
  | 'amex'
  | 'discover'
  | 'diners'
  | 'jcb'
  | 'maestro'
  | 'unionpay'
  | 'rupay'
  | 'unknown'

// The network arrives with inconsistent casing and spacing depending on who
// wrote the row — Stripe stores it lowercase ('visa'), Razorpay returns the
// network title-cased ('RuPay', 'MasterCard'), and the multi-word ones show up
// both spelled out and abbreviated. Normalising once is what stops a brand
// silently falling through to the generic card icon because nobody listed its
// particular spelling; the old switch had accumulated two or three literal cases
// per brand for exactly that reason, and RuPay had none.
const BRAND_KEYS_BY_ALIAS: Record<string, PaymentBrandKey> = {
  visa: 'visa',
  mastercard: 'mastercard',
  amex: 'amex',
  americanexpress: 'amex',
  discover: 'discover',
  diners: 'diners',
  dinersclub: 'diners',
  jcb: 'jcb',
  maestro: 'maestro',
  unionpay: 'unionpay',
  rupay: 'rupay',
}

export const resolvePaymentBrandKey = (brand: string | undefined): PaymentBrandKey =>
  BRAND_KEYS_BY_ALIAS[(brand ?? '').replace(/[\s_-]/g, '').toLowerCase()] ?? 'unknown'
